import { useMutation, useQueryClient } from 'libs/query'
import { useTranslation } from 'libs/i18n'
import { useAxiosPrivate, useToast } from 'shared/hooks'
import { apiRoutes } from 'config/apiRoutes'
import { queryKeys } from 'config/queryKeys'
import type { FabricItem } from 'features/fabrics/types/fabrics.types'

type EditFabricVariables = {
	id: number
	data: Pick<FabricItem, 'name'>
}

type UseEditFabricMutationProps = {
	onSuccess: () => void
}

export const useEditFabricMutation = ({ onSuccess }: UseEditFabricMutationProps) => {
	const { t } = useTranslation()
	const axiosPrivate = useAxiosPrivate()
	const queryClient = useQueryClient()

	const { mutate: editFabricMutation, isPending: isEditFabricLoading } = useMutation({
		mutationFn: ({ id, data }: EditFabricVariables) => {
			return axiosPrivate.patch(apiRoutes.fabric(String(id)), data)
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: queryKeys.fabrics.all })
			useToast({ type: 'success', message: t('Fabric edited') })()

			onSuccess()
		},
		onError: () => {
			useToast({ type: 'error', message: t('Something went wrong') })()
		}
	})

	return {
		editFabricMutation,
		isEditFabricLoading
	}
}
